module.exports = __webpack_public_path__ + "img/day.448cef74.png";